module.exports = __webpack_public_path__ + "img/03-2-2业务评估.069cfdfa.svg";